"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16 2.07c0-.92-1.08-1.38-1.7-.73L12 3.7 8.7.31a.98.98 0 00-1.4 0L4 3.7 1.7 1.34C1.09.69 0 1.14 0 2.07v8.9C0 11.53.45 12 1 12h14c.55 0 1-.46 1-1.04V2.07z"
}));

exports["default"] = _default;